import { Component, Inject, OnInit } from '@angular/core';
import { UserPermissionsService } from 'app/modules/settings/services/user-permissions.service';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { GridDataResult } from '@progress/kendo-angular-grid';
import { orderBy, SortDescriptor } from '@progress/kendo-data-query';

@Component({
    selector: 'app-permission-set-users',
    templateUrl: './permission-set-users.component.html',
    styleUrls: ['./permission-set-users.component.scss'],
})
export class PermissionSetUsersComponent implements OnInit {
    grid: GridDataResult;
    sortable = {
        mode: 'single',
        allowUnsort: true,
    };

    sort: SortDescriptor[] = [
        {
            field: 'lFName',
            dir: 'asc',
        },
    ];

    allResults: boolean = false;
    scrollable = 'scrollable';

    results: any[];
    loading = true;

    constructor(
        private permissionSetService: UserPermissionsService,
        @Inject(MAT_DIALOG_DATA) public data: any
    ) {}

    ngOnInit(): void {
        if (this.data) {
            this.getData();
        }
    }

    getData() {
        this.permissionSetService.getUsersAssigned(this.data.permission.permissionSetKey).subscribe(
            (result) => {
                this.results = result;
                this.reloadGrid();
                this.loading = false;
            },
            (error) => {
                this.loading = false;
            }
        );
    }

    reloadGrid() {
        try {
            this.grid = {
                data: orderBy(this.results, this.sort),
                total: this.results.length,
            };
        } catch (e) {}
    }

    sortChange(sort: SortDescriptor[]): void {
        this.sort = sort;
        this.reloadGrid();
    }
}
